
export const MemberLedgerScreenAccessCustomerType = [
  'member',
  'memberelect',
  'spouseofdeceased',
  'seniordependentassociate',
];